import { flexRowCenterCenter } from '../../../common/styles/flex';
import {
  CONTROLS_BAR_HEIGHT,
  SEEK_BAR_HEIGHT_LARGE,
  SEEK_BAR_HEIGHT_MEDIUM,
} from '../../../common/utils/common.constants';
import { PlayerSizesTypes } from '../../../common/store/store.types';
import { SITE_VARIABLES } from '../../../common/styles/variables';

interface StylesObject {
  buttonWrapperStyle: { [key: string]: any };
  buttonTextStyle: { [key: string]: any };
  buttonStyle: { [key: string]: any };
}

const buttonWrapper = {
  ...flexRowCenterCenter,
  pointerEvents: 'auto',
  cursor: 'pointer',
  large: {
    marginTop: '4px',
    marginLeft: '8px',
  },
  extraLarge: {
    marginTop: '5px',
    marginLeft: '12px',
  },
};

const button = {
  pointerEvents: 'auto',
  cursor: 'pointer',
  position: 'absolute',
  boxShadow: 'rgba(0, 0, 0, 0.5) 2px 2px 8px 0px',
  medium: {
    bottom: `${CONTROLS_BAR_HEIGHT + SEEK_BAR_HEIGHT_MEDIUM + 6}px`,
    left: '13px',
  },
  large: {
    bottom: `${CONTROLS_BAR_HEIGHT + SEEK_BAR_HEIGHT_LARGE + 8}px`,
    left: '20px',
  },
  extraLarge: {
    bottom: `${CONTROLS_BAR_HEIGHT + SEEK_BAR_HEIGHT_LARGE + 15}px`,
    left: '28px',
  },
};

const buttonText = {
  fontSize: SITE_VARIABLES.FONT_SIZE.TINY,
  fontFamily: SITE_VARIABLES.TEXT_FONT_FAMILY.LATO,
  color: SITE_VARIABLES.COLORS.WHITE,
  marginLeft: '6px',
};

export const getMoreVideosButtonStyleObject = (playerSize: PlayerSizesTypes): StylesObject => {
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';

  return ({
    buttonWrapperStyle: [
      buttonWrapper,
      largeSize && buttonWrapper.large,
      extraLargeSize && buttonWrapper.extraLarge,
    ],
    buttonStyle: [
      button,
      mediumSize && button.medium,
      largeSize && button.large,
      extraLargeSize && button.extraLarge,
    ],
    buttonTextStyle: {
      ...buttonText,
    },
  });
};
